import Vector2 from "../../math/Vector2";
import SPBogey from "../SPBogey";

export default class Tanker extends SPBogey {

    hp: number = 4;
    maxHP: number = 4;
    fireRate: number = 1;
    xpReward: number = 4;

    Draw(): void {
        super.Draw();

        this.ctx.fillStyle = '#ff5555';
        for (let theta = 0; theta < 2 * Math.PI; theta += 2 * Math.PI / this.hp) {
            const vec = Vector2.fromRadians(theta);
            this.engine.FillCircle(this.transform.position.add(vec.scale(this.size)), this.size/4);
        }
    }

}